export default __webpack_public_path__ + "static/media/icon-new-charge.ae56ef5f.svg";